import React from 'react';
import { useParams } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { getTour } from '../constants/markers';

const useStyles = makeStyles({
  iframe: {
    width: '100%',
    height: '100vh',
  },
});

export default function Tours() {
  let { tour, area } = useParams();
  const classes = useStyles();

  return (
    <iframe
      className={classes.iframe}
      src={getTour(tour, area).link}
      title='360 Tour'
      frameBorder='0'
    />
  );
}
